import styled from 'styled-components'

import { Button } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
export const ContainedAiButton = styled(Button)`
  background-color: ${props => props.theme.colors.ai.hover};
  color: ${props => props.theme.colors.text.inverse};
  border-color: ${props => props.theme.colors.ai.hover};

  &:hover {
    background-color: ${props => props.theme.colors.ai.hover};
    border-color: ${props => props.theme.colors.ai.hover};
  }
`

export const TextAiButton = styled(Button)`
  color: ${props => props.theme.colors.ai.hover};

  &:hover {
    background-color: ${props => props.theme.colors.ai.surface};
    color: ${props => props.theme.colors.ai.hover};
  }
`
